<script lang="ts">
  import { truncate } from 'lodash';
  import { DataTableCell } from 'svelte-materialify';
  import type { CategoryPropConfig } from '../../modules/projects/project.interface';
  import { CategoryPropType } from '../../modules/projects/project.interface';

  export let categoryProp: CategoryPropConfig;
  export let value: string;
</script>

{#if categoryProp.type === CategoryPropType.IMAGE}
  <DataTableCell class="pt-2">
    <img src={value} height="40" alt="" />
  </DataTableCell>
{:else if categoryProp.type === CategoryPropType.URL}
  <DataTableCell>
    <a href={value} target="_blank" title={value}>{truncate(value, { length: 33 })}</a>
  </DataTableCell>
{:else}
  <DataTableCell>
    <span>{value}</span>
  </DataTableCell>
{/if}
